
<iframe

            #iframe
            [src]="drawIoUrl"
            width="100%"
            height="100%"
            frameborder="0"
            style="border:0;"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
    ></iframe>

